import * as React from 'react';

/* eslint-disable react/prop-types */
import LinearthinkingDifferences from './LinearthinkingDifferences';
import LinearthinkingApplyToSkills from './LinearthinkingApplyToSkills';
import { ResponsiveContainer } from 'components/ResponsiveContainer';
import { SectionV3 } from 'components/SectionV3';

const LinearthinkingDifferencesAndApplyToSkillsBase = ({
  differences,
  application
}) => {
  return (
    <SectionV3>
      <ResponsiveContainer>
        <LinearthinkingDifferences data={differences} />
        <LinearthinkingApplyToSkills data={application} />
      </ResponsiveContainer>
    </SectionV3>
  );
};

export default LinearthinkingDifferencesAndApplyToSkillsBase;
